import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { ReportMenu } from "./reportMenu";

const DrawerHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: "0 16px",
});

const Reports = (props) => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <DrawerHeader>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={handleDrawerToggle}
              aria-label={open ? "Close drawer" : "Open drawer"}
              title={open ? "Close drawer" : "Open drawer"}
            >
              {theme.direction === "rtl" ? (
                open ? (
                  <ChevronRightIcon />
                ) : (
                  <ChevronLeftIcon />
                )
              ) : open ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
            {open && <Typography variant="h6">Report</Typography>}
          </div>
        </DrawerHeader>
        {open && (
          <Box sx={{ flexGrow: 1, p: 2 }}>
            <ReportMenu />
          </Box>
        )}
        <Box sx={{ flexGrow: 1, p: 2 }}>{props.children}</Box>
      </Box>
    </>
  );
};

export default Reports;
